"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var RatioBox_1 = require("../RatioBox");
exports.SearchIcon = function (_a) {
    var maintainProportions = _a.maintainProportions, children = _a.children, svgProps = tslib_1.__rest(_a, ["maintainProportions", "children"]);
    var iconSvg = (React.createElement("svg", tslib_1.__assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "5 5 14 14" }, svgProps),
        React.createElement("path", { fill: "currentColor", d: "M15.683 14.6l3.265 3.265a.2.2 0 010 .282l-.8.801a.2.2 0 01-.283 0l-3.266-3.265a5.961 5.961 0 111.084-1.084zm-4.727 1.233a4.877 4.877 0 100-9.754 4.877 4.877 0 000 9.754z" })));
    if (maintainProportions) {
        return (React.createElement(RatioBox_1.RatioBox, { height: "100%", "data-hook": "proportional-icon" }, iconSvg));
    }
    return iconSvg;
};
//# sourceMappingURL=SearchIcon.js.map